import { render, staticRenderFns } from "./AmountMultiplier.vue?vue&type=template&id=47228644"
import script from "./AmountMultiplier.vue?vue&type=script&lang=js"
export * from "./AmountMultiplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports